import { APP_DATE_FORMAT_MID } from "@/config/constants";
import { IEdoQuestion } from "@/shared/model/edo-question.model";
import { getQuestionIcon } from "@/shared/util/question-utils";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  IconButton,
  ListItem,
  ListItemIcon,
  ListItemSecondaryAction,
  ListItemText,
} from "@/components/ui";
import { Pencil, MoreVertical, Trash2 } from "lucide-react";
import React, { useEffect, useState } from "react";
import { TextFormat } from "react-jhipster";
import { cn } from "@/shared/util/cn";

interface IQuestionRowProps {
  question: IEdoQuestion;
  onView: (question: IEdoQuestion) => void;
  onEdit: (question: IEdoQuestion) => void;
  onDelete: (question: IEdoQuestion) => void;
}

export const QuestionRow = (props: IQuestionRowProps) => {
  const [localQuestion, setLocalQuestion] = useState<IEdoQuestion>(props.question);
  const { question, onView: handleView, onEdit: handleEdit, onDelete: handleDelete } = props;

  useEffect(() => {
    if (question) {
      setLocalQuestion(question);
    }
  }, [question]);

  return (
    <ListItem
      className={cn(
        "flex cursor-pointer items-center gap-3 px-5 py-3.5 transition-colors hover:bg-primary/5"
      )}
      onClick={() => handleView(localQuestion)}
    >
      <ListItemIcon>
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl bg-primary/10 text-primary">
          {getQuestionIcon(question.type)}
        </div>
      </ListItemIcon>
      <ListItemText
        primary={
          <span className="text-sm font-semibold text-[var(--color-mockup-text)]">
            {localQuestion.description}
          </span>
        }
        secondary={
          <span className="text-xs text-[var(--color-mockup-text-light)]">
            <TextFormat
              type="date"
              value={localQuestion.createdAt}
              format={APP_DATE_FORMAT_MID}
              locale="it"
            />
          </span>
        }
      />
      <ListItemSecondaryAction onClick={(e) => e.stopPropagation()} className="ml-2">
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <IconButton
              aria-label="Menu domanda"
              className="h-8 w-8 rounded-full text-[var(--color-mockup-text-light)] hover:bg-[var(--color-mockup-border)]/50 hover:text-[var(--color-mockup-text)]"
            >
              <MoreVertical className="h-4 w-4" />
            </IconButton>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="min-w-[200px]">
            <DropdownMenuItem
              onSelect={(e) => {
                e.preventDefault();
                handleEdit(localQuestion);
              }}
            >
              <Pencil className="h-4 w-4" />
              Modifica domanda
            </DropdownMenuItem>
            <DropdownMenuItem
              onSelect={(e) => {
                e.preventDefault();
                handleDelete(localQuestion);
              }}
              className="text-[var(--color-mockup-coral)] focus:text-[var(--color-mockup-coral)]"
            >
              <Trash2 className="h-4 w-4" />
              Elimina domanda
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </ListItemSecondaryAction>
    </ListItem>
  );
};

export default QuestionRow;
